import { getGetterTypesForService } from 'shared/utils/createServiceStore.js';
import { METRICS_SERVICE_KEY } from './metricsEnum.js';

export default getGetterTypesForService(METRICS_SERVICE_KEY);
